module.exports = __webpack_public_path__ + "static/media/urban-media.b784c6ca.png";